import IEnviarPinRequestDTO from '../entities/IEnviarPinRequestDTO'
import IEnviarPinResponseDTO from '../entities/IEnviarPinResponseDTO'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IEnviarPinTmovPay {
  execute(data: IEnviarPinRequestDTO): Promise<IEnviarPinResponseDTO>
}

export default class EnviarPinTmovPayImpl implements IEnviarPinTmovPay {
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}

  public async execute(
    data: IEnviarPinRequestDTO,
  ): Promise<IEnviarPinResponseDTO> {
    const response = await this.pagamentoRepository.enviarPin(data)
    return response
  }
}
